/* Lista Mikołaja (baza Bobolio) – śnieg w tle, licznik, kalendarz, koszyk, pojawianie się sekcji, ruch zdjęcia w banerze */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Śnieg w tle (lekki: bez shadowBlur, ~30 kl./s, pauza gdy karta ukryta) ---------- */
  function lasers() {
    if (document.querySelector('.bb-lasers')) return;
    var c = document.createElement('canvas');
    c.className = 'bb-lasers lm-snow';
    c.setAttribute('aria-hidden', 'true');
    document.body.prepend(c);
    var ctx = c.getContext('2d', { alpha: true });
    var W = 0, H = 0, scale = 1, flakes = [];
    function size() {
      W = document.documentElement.clientWidth; H = window.innerHeight;
      scale = W > 1600 ? 0.75 : 1;
      c.width = Math.round(W * scale); c.height = Math.round(H * scale);
      c.style.width = W + 'px'; c.style.height = H + 'px';
      ctx.setTransform(scale, 0, 0, scale, 0, 0);
    }
    function flake(top) {
      var r = Math.random() < 0.12 ? 2.8 + Math.random() * 2.2 : 0.9 + Math.random() * 1.7;
      return { x: Math.random() * W, y: top ? -10 : Math.random() * H, r: r,
        vy: 0.35 + r * 0.32, sway: Math.random() * 6.28, sw: 0.006 + Math.random() * 0.012,
        a: 0.45 + Math.random() * 0.5, rot: Math.random() * 6.28, vr: (Math.random() - 0.5) * 0.02 };
    }
    var resizeT;
    size();
    window.addEventListener('resize', function () { clearTimeout(resizeT); resizeT = setTimeout(size, 150); });
    var count = W < 750 ? 45 : 110;
    for (var i = 0; i < count; i++) flakes.push(flake(false));
    var running = true, last = 0;
    document.addEventListener('visibilitychange', function () {
      running = !document.hidden;
      if (running) requestAnimationFrame(frame);
    });
    function frame(t) {
      if (!running) return;
      requestAnimationFrame(frame);
      if (t - last < 33) return;
      last = t;
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < flakes.length; i++) {
        var f = flakes[i];
        f.y += f.vy; f.sway += f.sw; f.x += Math.sin(f.sway) * 0.45; f.rot += f.vr;
        ctx.globalAlpha = f.a;
        if (f.r > 2.6) { /* większe płatki – gwiazdka z 6 ramion */
          ctx.save(); ctx.translate(f.x, f.y); ctx.rotate(f.rot);
          ctx.strokeStyle = 'rgba(120,160,205,0.9)'; ctx.lineWidth = 1.1;
          for (var k = 0; k < 3; k++) { ctx.rotate(1.0472); ctx.beginPath(); ctx.moveTo(-f.r * 2, 0); ctx.lineTo(f.r * 2, 0); ctx.stroke(); }
          ctx.restore();
        } else {
          ctx.fillStyle = '#fff'; ctx.strokeStyle = 'rgba(130,165,205,0.55)'; ctx.lineWidth = 0.8;
          ctx.beginPath(); ctx.arc(f.x, f.y, f.r, 0, 6.283); ctx.fill(); ctx.stroke();
        }
        if (f.y > H + 12) flakes[i] = flake(true);
      }
      ctx.globalAlpha = 1;
    }
    if (!reduce) requestAnimationFrame(frame);
  }

  /* ---------- Licznik do daty (sekcja „Termin zamówień”) ---------- */
  function countdowns() {
    document.querySelectorAll('[data-lm-count]:not([data-on])').forEach(function (el) {
      el.setAttribute('data-on', '1');
      var end = new Date(el.getAttribute('data-lm-count')).getTime();
      if (isNaN(end)) return;
      var u = {}; el.querySelectorAll('[data-u]').forEach(function (b) { u[b.dataset.u] = b; });
      var done = el.parentNode.querySelector('.lm-dl__done');
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var d = Math.max(0, Math.floor((end - Date.now()) / 1000));
        if (d === 0 && done) { el.hidden = true; done.hidden = false; return; }
        u.d.textContent = Math.floor(d / 86400);
        u.h.textContent = pad(Math.floor(d % 86400 / 3600));
        u.m.textContent = pad(Math.floor(d % 3600 / 60));
        u.s.textContent = pad(d % 60);
        setTimeout(tick, 1000);
      }
      tick();
    });
  }

  /* ---------- Kalendarz adwentowy: w grudniu dzisiejsze okienko świeci ---------- */
  function advent() {
    var now = new Date();
    if (now.getMonth() !== 11) return;
    document.querySelectorAll('[data-lm-advent] .lm-day[data-day="' + now.getDate() + '"]').forEach(function (d) { d.classList.add('is-today'); });
  }

  /* ---------- Pojawianie się elementów ---------- */
  function reveal() {
    var els = document.querySelectorAll('[data-bb-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Baner: zdjęcie lekko podąża za myszką ---------- */
  function tilt() {
    if (reduce) return;
    document.querySelectorAll('[data-bb-tilt]').forEach(function (wrap) {
      var img = wrap.querySelector('.bb-hero__product');
      if (!img) return;
      var pending = false, ex = 0, ey = 0;
      wrap.addEventListener('mousemove', function (e) {
        ex = e.clientX; ey = e.clientY;
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () {
          pending = false;
          var r = wrap.getBoundingClientRect();
          var x = (ex - r.left) / r.width - 0.5;
          var y = (ey - r.top) / r.height - 0.5;
          img.style.transform = 'translate3d(' + (x * 18) + 'px,' + (y * 14) + 'px,0) rotate(' + (x * 3) + 'deg)';
        });
      });
      wrap.addEventListener('mouseleave', function () { img.style.transform = ''; });
    });
  }


  /* ---------- Liczniki (count-up) ---------- */
  function counters() {
    var els = document.querySelectorAll('[data-bb-count]:not([data-done])');
    if (!els.length) return;
    function run(el) {
      el.setAttribute('data-done', '1');
      var to = parseFloat(el.getAttribute('data-bb-count')) || 0, t0 = null;
      if (reduce) { el.textContent = to; return; }
      function step(t) {
        if (!t0) t0 = t;
        var k = Math.min((t - t0) / 1400, 1);
        el.textContent = Math.round(to * (1 - Math.pow(1 - k, 3)));
        if (k < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Przycisk „Zamów” w sekcjach strony produktu → do przycisku kupna ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-bb-totop]');
    if (!a) return;
    var buy = document.querySelector('.product-form__submit, .product__info-wrapper');
    if (!buy) return;
    e.preventDefault();
    buy.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });


  /* ---------- Karty produktów: „Dodaj pod choinkę” bez przeładowania, otwiera koszyk Shrine ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lm-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-busy')) return;
    btn.classList.add('is-busy');
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: +btn.getAttribute('data-lm-add'), quantity: 1 }] };
    if (drawer && drawer.getSectionsToRender) body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
    fetch((window.routes && window.routes.cart_add_url || '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      btn.classList.remove('is-busy');
      if (res.status) { alert(res.description || res.message); return; }
      if (drawer && drawer.renderContents && res.sections) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(res);
      } else { location.href = (window.routes && window.routes.cart_url) || '/cart'; }
    }).catch(function () { btn.classList.remove('is-busy'); location.href = '/cart'; });
  });


  /* ---------- Sortowanie w kolekcji ---------- */
  document.addEventListener('change', function (e) {
    var s = e.target.closest('[data-lm-sort]');
    if (!s) return;
    var u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page');
    location.href = u.toString();
  });

  /* ---------- Płynne przejścia między stronami (fade) ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]');
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || a.target === '_blank') return;
    if (a.hasAttribute('data-bb-totop') || a.closest('cart-drawer, .drawer, [data-no-fade]')) return;
    var url = new URL(a.href, location.href);
    if (url.origin !== location.origin || url.hash && url.pathname === location.pathname) return;
    if (document.startViewTransition || reduce) return; /* przeglądarki z View Transitions robią to same */
    e.preventDefault();
    document.documentElement.classList.add('lm-leaving');
    setTimeout(function () { location.href = url.toString(); }, 220);
  });
  window.addEventListener('pageshow', function () { document.documentElement.classList.remove('lm-leaving'); });


  /* ---------- Sekcje wjeżdżają płynnie przy przewijaniu ---------- */
  function sections() {
    var list = document.querySelectorAll('#MainContent > .shopify-section:not(.is-seen)');
    if (!('IntersectionObserver' in window) || reduce) { list.forEach(function (s) { s.classList.add('is-seen'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-seen'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px 25% 0px', threshold: 0 });
    list.forEach(function (s, i) { if (i === 0) s.classList.add('is-seen'); else io.observe(s); });
  }

  function init() { document.documentElement.classList.add('bb-js'); lasers(); reveal(); tilt(); counters(); countdowns(); advent(); sections(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function () { reveal(); tilt(); counters(); countdowns(); advent(); sections(); });
})();
